module.exports = __webpack_public_path__ + "img/2@2x.7250bdc8.png";